export default __webpack_public_path__ + "static/media/Belt of Dark Terror.bc1e2e2b.jpg";